import React, { useEffect, useRef, useState } from 'react';

interface ShaveProps {
  maxHeight: number;
  tag?: string;
  character?: string;
}

const Shave: React.FC<ShaveProps> = ({
  maxHeight,
  tag = 'div',
  character = '…',
  children,
}) => {
  const ref = useRef(null);
  const [trimmedText, setTrimmedText] = useState(children);

  const updateText = () => {
    if (ref?.current?.offsetHeight > maxHeight) {
      const lastSpace = trimmedText.toString().lastIndexOf(' ');

      if (lastSpace >= 0) {
        setTrimmedText(trimmedText.toString().substr(0, lastSpace));
      }
    }
  };

  useEffect(() => {
    updateText();
  }, [children, trimmedText, maxHeight]);

  useEffect(() => {
    updateText();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', updateText);

    setTimeout(() => {
      updateText();
    }, 250);

    return () => {
      window.removeEventListener('resize', updateText);
    };
  });

  return React.createElement(
    tag,
    {
      ref: (element) => (ref.current = element),
      title: children.toString(),
    },
    trimmedText.toString(),
    children.toString() !== trimmedText.toString() && character,
  );
};

export default Shave;
